import { useState } from "react";
import { supabase } from "../supabaseClient";

export function useExamQuestions() {
  const [examQuestions, setExamQuestions] = useState([]);
  const [loadingExamQuestions, setLoadingExamQuestions] = useState(false);

  const fetchExamQuestions = async (examSetId) => {
    if (!examSetId) return [];

    setLoadingExamQuestions(true);

    const { data, error } = await supabase
      .from("exam_questions")
      .select("id, question_number, question_text, options, correct_answer, topic, domain, difficulty")
      .eq("exam_set_id", examSetId)
      .order("question_number", { ascending: true });

    if (error) {
      console.error("FETCH EXAM QUESTIONS ERROR:", error);
      alert(error.message);
      setExamQuestions([]);
      setLoadingExamQuestions(false);
      return [];
    }

    const normalizedQuestions = (data || []).map((q) => ({
      id: q.id,
      question_number: q.question_number,
      question: q.question_text,
      options: q.options,
      correct_answer: q.correct_answer,
      topic: q.topic,
      domain: q.domain,
      difficulty: q.difficulty,
    }));

    setExamQuestions(normalizedQuestions);
    setLoadingExamQuestions(false);

    return normalizedQuestions;
  };

  return {
    examQuestions,
    loadingExamQuestions,
    fetchExamQuestions,
  };
}